module.exports = __webpack_public_path__ + "img/icon_LingHun_16x16.8f9b7639.svg";